import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-revisit-pyq-dialog',
  templateUrl: './revisit-pyq-dialog.component.html',
  styleUrls: ['./revisit-pyq-dialog.component.css']
})
export class RevisitPyqDialogComponent implements OnInit {
  isCheckboxChecked:any = false;
  constructor(public dialogRef: MatDialogRef<RevisitPyqDialogComponent>,  @Inject(MAT_DIALOG_DATA) public data: any,private router: Router) { }

  ngOnInit(): void {
    localStorage.removeItem('showAnseredQuestions');
  }
  close(){
    this.dialogRef.close();
  }
  navigateToPreviousPage(){
    this.dialogRef.close();
    if(this.isCheckboxChecked){
      localStorage.setItem('showAnseredQuestions','false');
    }  
    this.router.navigateByUrl('selfLearn-V2/pyp-chapter-questions');
  }
  seeAnswers(){
    this.isCheckboxChecked =   !this.isCheckboxChecked;
  }
}
